var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { DateFormatPipe } from './date-format/date-format';
import { TruncatePipe } from './truncate/truncate';
import { ThumbnailPipe } from './thumbnail/thumbnail';
import { TitlePipe } from './title/title';
import { DatePipe } from '@angular/common';
import { ThousandPipe } from './thousand/thousand';
var PipesModule = /** @class */ (function () {
    function PipesModule() {
    }
    PipesModule = __decorate([
        NgModule({
            declarations: [DateFormatPipe,
                TruncatePipe,
                ThumbnailPipe,
                TitlePipe,
                ThousandPipe],
            imports: [],
            exports: [DateFormatPipe,
                TruncatePipe,
                ThumbnailPipe,
                TitlePipe,
                ThousandPipe],
            providers: [DatePipe]
        })
    ], PipesModule);
    return PipesModule;
}());
export { PipesModule };
//# sourceMappingURL=pipes.module.js.map


// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts.pre-build-optimizer.js